/**
 * GH#1201 — ¿hay alguien que vaya a usar la lista de sitios del tenant?
 *
 * `GET /multi-site/sites` es del tenant (`PlanFeatureGuard`, fail-closed a propósito: sin tenant listaría los sitios de TODOS). Para quien no tiene
 * tenant el API contesta 403, y el layout lo pedía en cada página del panel de administración. La lista solo la pinta el selector de sitios de la
 * cabecera, que no se muestra ni en `/admin` ni sin tenant (`Header.tsx`: `!isAdminRoute && tenant`); la página de sitios hace su propia llamada.
 */
export interface QuienPideSitios {
  isAdminRoute: boolean;
  role?: string | null;
  tenantId?: string | null;
}

export const debePedirSitios = ({ isAdminRoute, role, tenantId }: QuienPideSitios): boolean =>
  !isAdminRoute && role !== 'SUPER_ADMIN' && Boolean(tenantId);
